import React from 'react'
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaGithub } from "react-icons/fa";
import { contactImg } from "../../assets/index";
import { useTheme } from '../theme/ThemeContext';
const ContactLeft = () => {
  const {darkTheme} = useTheme();
  return (
    <div className={darkTheme?"w-full lgl:w-[35%] h-full bg-gradient-to-r from-bodyColor to-[gray] p-4 lgl:p-8 rounded-lg  flex flex-col gap-8 justify-center"
  :"w-full lgl:w-[35%] h-full bg-gradient-to-r from-grayBodyColor to-[gray] p-4 lgl:p-8 rounded-lg  flex flex-col gap-8 justify-center"
}>
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className={darkTheme?"text-3xl font-bold text-white"
        :"text-3xl font-bold text-black"}>Rootchy MADEUS</h3>
        <p className={darkTheme?"text-lg font-normal text-gray-400"
        :"text-black font-normal text-black-400"}>
          Full-Stack Developer
        </p>
        <p className={darkTheme?"text-base text-gray-400 tracking-wide"
        :"text-black text-black-400 tracking-wide"}>
        I'm a full-stack developer with expertise in utilizing Django, React.js, HTML, and 
        CSS to create comprehensive web applications. My skill set spans both the
         front-end and back-end development, enabling me to build robust and responsive 
         websites with seamless user experiences.
        </p>
        <p className={darkTheme?"text-base text-gray-400 flex items-center gap-2"
        :"text-black text-black-400 flex items-center gap-2"}>
          Phone: <span className={darkTheme?"text-lightText":"text-black"}>+509 4111-5806</span>
        </p>
        <p className={darkTheme?"text-base text-gray-400 flex items-center gap-2"
        :"text-black text-black-400 flex items-center gap-2"}>
          Email: <span className={darkTheme?"text-lightText":"text-black"}>madeusrootchy1@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className={darkTheme?"text-base uppercase font-titleFont mb-4"
        :"text-black uppercase font-titleFont mb-4"}>Find me in</h2>
        <div className="flex gap-4">
        
        <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
          <a href="https://twitter.com/rootchy" className="bannerIcon">
            <FaTwitter />
          </a>

          </span>
          <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
            <a href="https://www.linkedin.com/in/rootchymad/" className="bannerIcon">
            <FaLinkedinIn />
            </a>
          </span>
          <span className={darkTheme?"bannerIcon":"bannerIcon2"}>
            <a href="https://github.com/MadeusRootchy" className="bannerIcon">
            <FaGithub />
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ContactLeft;